import React from "react";

// components
import Button from "@/shared/Button";

// assets
import styles from "@/assets/styles/components/restricted-view.module.scss";

interface IRestrictedView {
  title?: string | React.ReactNode;
  subtitle?: string | React.ReactNode | JSX.Element;
  buttonText: string;
  onButtonClick: () => void;
}

const RestrictedView = (props: IRestrictedView) => {
  const { title, subtitle, buttonText, onButtonClick } = props;


  return (
    <div className={styles["locl-restricted-view"]}>
      {
        title && (
          <div className={styles["locl-restricted-view__title"]}>
            { title }
          </div>
        )
      }
      <Button
        onClick={onButtonClick}
        className={styles["locl-restricted-view__button"]}
      >
        { buttonText }
      </Button>
      {
        subtitle && (
          <div className={styles["locl-restricted-view__info"]}>
            { subtitle }
          </div>
        )
      }
    </div>
  )
}

export default RestrictedView;
